export function hasProp(schema, targetPropName) {
	const prop = schema?.items?.properties || schema?.properties;
	if (!prop) {
		return false;
	}
	if (Object.keys(prop).includes(targetPropName)) {
		return true;
	}
	for (let childKey in prop) {
		if (hasProp(prop[childKey], targetPropName)) {
			return true;
		}
	}
	return false;
}
